// Caps the number of shortest paths the discovery-tree query returns.
//
// This is a BYTE-SIZE HEURISTIC, not a guarantee. The backend's real guard is a
// post-hoc 6MB response cap (my.go / size.go) measured on the MATERIALIZED
// response. A low path count with large per-node payloads (e.g. TLS-cert
// preseeds embedding multi-KB certificates) can still exceed 6MB — a single
// oversized path can trip it even at this limit — and surface as HTTP 413.
// When that happens the drawer's 413 branch ("Discovery tree too large to
// display", PreseedDrawer.tsx) is the INTENDED terminal fallback; it is not
// dead code and there is no auto-retry with a smaller limit. Lowering this
// value trades path breadth for a lower chance of hitting the 6MB cap.
export const PRESEED_TREE_LIMIT = 50;
